/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */

import React, { useState, useEffect } from 'react';
import Header from '../../Compoents/Header';
import Footer from '../../Compoents/Footer';
import medtrustBg from "../../admin/assets/medtrust.jpg";
import { FaHeartbeat, FaBrain, FaBone, FaWeight, FaLungs, FaHeart, FaTransgender, FaUserMd } from "react-icons/fa";
import { GiKidneys, GiLiver, GiFemale, GiArtificialIntelligence, GiKneeCap, GiHumanPyramid, GiBreastplate, GiNoseFront } from "react-icons/gi";
import { MdOutlinePregnantWoman, MdOutlineScience, MdPregnantWoman, MdOutlineMedicalServices } from "react-icons/md";
import { BsFillHeartPulseFill } from "react-icons/bs";
import { RiVirusLine } from "react-icons/ri";
import MedtrustHeader from '../../Compoents/MedtrustHeader';
import MedtrustFooter from '../../Compoents/MedtrustFooter';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import AsSimpleAsCard from './AsSimpleAsCard';
import HospitalLayout from './HospitalLayout';
import { motion } from "framer-motion";
import { CheckCircle2, Users, Shield, Globe, Stethoscope, CheckCircle, MessageSquare, Check } from "lucide-react";
import MedicalDeviceLayout from './MedicalDeviceLayout';





const OurTherapeuticSpecialties = () => {

  const specialties = [
    { id: "01", img: "assets/imgs/treatment_icon/cardiology_transparent.png", name: "Cardiology" },
    { id: "02", img: "assets/imgs/treatment_icon/Respiratory_transparent.png", name: "Respiratory" },
    { id: "03", img: "assets/imgs/treatment_icon/Endocrine-transparent.png", name: "Endocrine" },
    { id: "04", img: "assets/imgs/treatment_icon/Gastroenterology-transparent.png", name: "Gastroenterology" },
    { id: "05", img: "assets/imgs/treatment_icon/Kidney___Urology transparent.png", name: "Kidney & Urology" },
    { id: "06", img: "assets/imgs/treatment_icon/Stroke___Paralysis transparent.png", name: "Stroke & Paralysis" },
    { id: "07", img: "assets/imgs/treatment_icon/Eye_Surgery- transparent.png", name: "Eye Surgery" },
    { id: "08", img: "assets/imgs/treatment_icon/Ear_Surgery-transparent.png", name: "Ear Surgery" },

    { id: "09", img: "assets/imgs/treatment_icon/TCM__Traditional_Chinese_Medicine_-transparent.png", name: "TCM" },
    { id: "10", img: "assets/imgs/slider-text/10. Neurology.png", name: "Rehabilitation" },
    { id: "11", img: "assets/imgs/treatment_icon/Cancer-transparent.png", name: "Cancer" },
    { id: "12", img: "assets/imgs/treatment_icon/Brain___Spine_Surgery-transparent.png", name: "Brain & Spine Surgery" },
    { id: "13", img: "assets/imgs/treatment_icon/Breast_Surgery-transparent.png", name: "Breast Surgery" },
    { id: "14", img: "assets/imgs/treatment_icon/Hip___Joint_Replacement transparent.png", name: "Hip & Joint Replacement" },
    { id: "15", img: "assets/imgs/treatment_icon/General_Surgery transparent.png", name: "General Surgery" },
    { id: "16", img: "assets/imgs/treatment_icon/Pediatric_Surgery- transparent.png", name: "Pediatric Surgery" },
    { id: "17", img: "assets/imgs/treatment_icon/Plastic_Surgery- transparent.png", name: "Plastic surgery" },
    { id: "18", img: "assets/imgs/treatment_icon/Arthritis___Joint_Pain_Management- transparent.png", name: "Arthritis & Joint Pain Management" },
    { id: "19", img: "assets/imgs/treatment_icon/Antiaging_Treatment transparent.png", name: "Antiaging Treatment" },
    { id: "20", img: "assets/imgs/treatment_icon/Stem_Cell_Therapy-transparent.png", name: "Steam Cell Therapy" },
    { id: "21", img: "assets/imgs/treatment_icon/Sports_Medicine-transparent.png", name: "Sports medicine" },
    { id: "22", img: "assets/imgs/treatment_icon/Oral_Care-transparent.png", name: "Oral care" },
    { id: "23", img: "assets/imgs/treatment_icon/Target_Organ_Check-ups-transparent.png", name: "Target organ checks up" },
    { id: "24", img: "assets/imgs/treatment_icon/Diabetics_Management-transparent.png", name: "Diabetics Management" },
    { id: "25", img: "assets/imgs/treatment_icon/Obesity_Management-transparent.png", name: "Obesity Management" },
    { id: "26", img: "assets/imgs/treatment_icon/Gynecological_Treatment-transparent.png", name: "Gynecological Treatment" },
    { id: "27", img: "assets/imgs/treatment_icon/IVF-transparent.png", name: "IVF" },
    { id: "28", img: "assets/imgs/treatment_icon/Specialized_Health_Check-up-transparent.png", name: "Specialized Health Check-up" },







  ];


  return (
    <div className='successfull-experience bg-white'>
      <div className="successfull-body container">

        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-2">Medical Specialties We Cover</h2>
          <p className="text-white text-lg">
            Comprehensive healthcare services with world-class medical expertise
          </p>
        </div>

        <div className="row my-4">
          {specialties.map((item) => (
            <div key={item.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div className="succ-experi-box text-center">
                <div className="count">
                  <h1>{item.id}</h1>
                </div>
                <img
                  src={item.img}
                  style={{ width: "85px", height: "85px", display: "inline-block" }}
                  alt={item.name}
                />
                <p>{item.name}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}


const SlidingBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'assets/imgs/banner/medtrust_banner6.png',
      title: 'Receive Second Opinion Consultations:',
      subtitle: '',
      description: [
        '• Second opinion difference from the first',
        '• Reviles better treatment options from the first',
        '• Receive written review reports & differences from multiple experts within 7 days',
        '• Receive online video consultation with experts'
      ],
      buttonText: 'Learn More'
    },
    {
      image: 'assets/imgs/banner/medtrust_banner1.png',
      title: 'Evaluation Based Pre-Consultations:',
      subtitle: '',
      description: [
        '• Pre-treatment evaluations',
        '• Personalized treatment plans',
        '• Post-treatment follow-up',
      ],
      buttonText: 'Get Started'
    },
    {
      image: 'assets/imgs/banner/medtrust_banner2.png',
      title: 'Consultation Without Language & Distance barrier:',
      subtitle: '',
      description: [
        '• Bi-lingual patient advocacy',
        '• Bi-lingual Telemedicine consultancy',
        '• Multi-disciplinary care coordination',
      ],
      buttonText: 'Explore Now'
    },
    {
      image: 'assets/imgs/banner/medtrust_banner3.png',
      title: 'Receive Medical Service Before Travel:',
      subtitle: '',
      description: [
        '• Medical Travel Documentation',
        '• Visa assistance & documentation',
        '• Flight booking & accommodation',
      ],
      buttonText: 'Explore Now'
    },
    {
      image: 'assets/imgs/banner/medtrust_banner4.png',
      title: 'Receive Medical Service During Treatment:',
      subtitle: '',
      description: [
        '• 24/7 Multilingual patient advocacy until treatment finish',
        '• Emergency response and crisis management',
        '• International insurance claim assistance',
        '• Currency exchange and financial planning',
        '• Local guide services',
      ],
      buttonText: 'Explore Now'
    },
    {
      image: 'assets/imgs/banner/medtrust_banner5.png',
      title: 'Post Treatment Service:',
      subtitle: '',
      description: [
        '• Post treatment follow-up',
        '• Post treatment Bi-lingual expert’s consultations',
        '• Post treatment medicine logistics service',

      ],
      buttonText: 'Explore Now'
    }
  ];


  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative w-full h-[90vh] overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-transform duration-700 ease-in-out ${index === currentSlide ? 'translate-x-0' : index < currentSlide ? '-translate-x-full' : 'translate-x-full'
            }`}
        >
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-black-200 bg-opacity-50"></div>
          </div>


        </div>
      ))}

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-10 hover:bg-opacity-20 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-md border border-white border-opacity-10 shadow-lg z-10"
        aria-label="Previous slide"
      >
        <ChevronLeft size={28} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-10 hover:bg-opacity-20 text-white p-3 rounded-full transition-all duration-300 backdrop-blur-md border border-white border-opacity-10 shadow-lg z-10"
        aria-label="Next slide"
      >
        <ChevronRight size={28} />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`transition-all duration-300 rounded-full ${index === currentSlide
                ? 'bg-white w-12 h-3'
                : 'bg-white bg-opacity-50 w-3 h-3 hover:bg-opacity-75'
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out 0.2s both;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out 0.4s both;
        }
      `}</style>
    </div>
  );
}



export const Medtrust = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [hoveredHospital, setHoveredHospital] = useState(null);
  const [expanded, setExpanded] = useState(null);





  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setActiveSection(id);
    setIsOpen(false);
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const features = [
    {
      title: 'End-to-End Support:',
      description: 'At SQUARE MEDTRUST, your health journey is our priority. We partner with a wide network of specialists to ensure you receive the right care. From your first consultation to the completion of your treatment, Post treatment follow-up & Post treatment medicine logistics service, we are by your side—providing multilingual support to ensure you\'re always understood.'
    },
    {
      title: 'Overcome Language Barriers:',
      description: 'Our multilingual advocates ensure clear communication between you and your healthcare team.'
    },
    {
      title: 'Your Needs Come First:',
      description: 'Our philosophy is simple; we listen to your needs. We follow a strict "Need-Based Service" (NBS) model. You will never be pressured into unnecessary treatments or services. Instead, our own medical team begins with a thorough consultation to understand your condition.'
    },
    {
      title: 'Expert-Led, Collaborative Care:',
      description: 'Our own in-house SQUARE MEDTRUST team of doctors provides comprehensive consultations to understand your condition and collaborate with specialists to design tailored treatment plans & costs.'
    },
    {
      title: 'Confident Decision-Making:',
      description: 'Through our "Multiple Opinion" strategy, you are in control, we empower you to compare options, choosing the plan that you and our medical experts feel is best for your health and well-being, with the confidence that comes from multiple professional opinions.'
    },
    {
      title: 'Dedicated International Patient Services:',
      description: 'SQUARE MEDTRUST offer comprehensive support for international patients, including multilingual staff, visa assistance, and tailored cultural services to make your stay seamless.'
    }
  ];








  const publications = [
    { name: 'YOURSTORY', color: 'text-red-500' },
    { name: 'GeekWire', color: 'text-orange-500' },
    { name: 'The Seattle Times', color: 'text-gray-800' },
    { name: '@HEALTH', color: 'text-red-500' },
    { name: 'livemint', color: 'text-yellow-500' },
    { name: 'YAHOO! FINANCE', color: 'text-purple-600' }
  ];



  const treatments = [
    { icon: <GiKneeCap className="text-white text-5xl" />, title: "Knee Replacement", price: "$4000" },
    { icon: <GiHumanPyramid className="text-white text-5xl" />, title: "Hip Replacement", price: "$5500" },
    { icon: <FaBrain className="text-white text-5xl" />, title: "Brain Tumor", price: "$5000" },
    { icon: <FaHeart className="text-white text-5xl" />, title: "Heart Bypass Surgery", price: "$4500" },
    { icon: <MdOutlineMedicalServices className="text-white text-5xl" />, title: "Valve Replacement", price: "$9500" },
    { icon: <GiBreastplate className="text-white text-5xl" />, title: "Breast Cancer", price: "$5000" },
    { icon: <FaLungs className="text-white text-5xl" />, title: "Lung Cancer", price: "$5500" },
    { icon: <GiNoseFront className="text-white text-5xl" />, title: "Rhinoplasty", price: "$1800" },
    { icon: <FaTransgender className="text-white text-5xl" />, title: "Breast Implants", price: "$2750" },
    { icon: <FaUserMd className="text-white text-5xl" />, title: "Hair Transplant", price: "$1400" },
    { icon: <RiVirusLine className="text-white text-5xl" />, title: "Cervical Cancer", price: "$4500" },
    { icon: <MdPregnantWoman className="text-white text-5xl" />, title: "Hysterectomy", price: "$3000" },
  ];

  const videoData = [
    {
      id: 1,
      title: "Liver Transplant in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/Q2FfpP0Vj8U",
    },
    {
      id: 2,
      title: "Bone Marrow Transplant in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/Np4v9klm6rQ",
    },
    {
      id: 3,
      title: "Mako Robotic Hip Replacement Surgery in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/6oR8p0mWhbA",
    },
    {
      id: 4,
      title: "Kidney Transplant Surgery in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/4bD1gA2sWUw",
    },
    {
      id: 5,
      title: "ED Treatment in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/9EKhIfYkA9U",
    },
    {
      id: 6,
      title: "Massalyne’s Breast Cancer Treatment in India | Patient Testimonial",
      url: "https://www.youtube.com/embed/6ti3bqWHEjU",
    },
    {
      id: 7,
      title: "Total Knee Replacement | Patient Testimonial",
      url: "https://www.youtube.com/embed/Y9pP8RkI1Tg",
    },
    {
      id: 8,
      title: "Another Patient Testimonial",
      url: "https://www.youtube.com/embed/FgO4eRHnU3s",
    },
  ];



  const faqs = [
    {
      id: 1,
      category: 'left',
      question: 'What is medical tourism, and why do people travel abroad for medical treatments?',
      answer: 'Medical tourism involves traveling to another country to receive medical treatment. People choose this option for various reasons including cost savings, access to specialized treatments, shorter wait times, and combining treatment with travel and recovery in a new environment.'
    },
    {
      id: 2,
      category: 'left',
      question: 'What is SQUARE MEDTRUST, and how does it work?',
      answer: 'SQUARE MEDTRUST is a medical travel facilitation platform assisting patients looking for treatment abroad. Our services range from giving options of treatment to patients, helping them find the budget they can afford. Handle their travel logistics - airport transfers, hotel booking, interpreters in hospitals etc.',
      isExpanded: true
    },
    {
      id: 3,
      category: 'left',
      question: 'How can I verify the credentials and reputation of a foreign hospital or doctor?',
      answer: 'You can verify credentials through medical board registrations, accreditation certificates, international healthcare certifications, patient reviews, and professional memberships. SQUARE MEDTRUST provides verified information about all listed hospitals and doctors to ensure your safety.'
    },
    {
      id: 4,
      category: 'left',
      question: 'How can SQUARE MEDTRUST help me find the right hospital and doctor for my treatment?',
      answer: 'SQUARE MEDTRUST connects you with a network of vetted hospitals and doctors specialized in your treatment area. Our team reviews your medical condition, preferences, and budget to recommend the most suitable healthcare providers for your specific needs.'
    },
    {
      id: 5,
      category: 'left',
      question: 'What types of medical procedures and treatments are available through SQUARE MEDTRUST',
      answer: 'SQUARE MEDTRUST offers a wide range of treatments including orthopedic surgery, cardiac care, oncology, dentistry, fertility treatments, cosmetic surgery, and many other specialized medical procedures across multiple countries.'
    },
    {
      id: 6,
      category: 'left',
      question: 'How do I request a cost estimate for my treatment through SQUARE MEDTRUST',
      answer: 'Simply submit your medical details and treatment requirements through our platform. Our team will gather information from partnered hospitals and provide you with comprehensive cost estimates including treatment, accommodation, and travel arrangements.'
    },
    {
      id: 7,
      category: 'left',
      question: 'How does SQUARE MEDTRUST ensure the quality and safety of the hospitals and doctors listed?',
      answer: 'We conduct thorough verification of all healthcare providers, including checking certifications, accreditations, patient outcomes, and safety records. We only list hospitals that meet international quality standards and have proven track records.'
    },
    {
      id: 8,
      category: 'left',
      question: 'Can SQUARE MEDTRUST assist with travel and accommodation arrangements for my medical trip?',
      answer: 'Yes, SQUARE MEDTRUST provides complete travel assistance including airport transfers, hotel bookings, visa support, and local transportation. We coordinate all logistics so you can focus on your treatment and recovery.'
    },
    {
      id: 9,
      category: 'left',
      question: 'Are there any language barriers, and how can I communicate effectively with medical staff?',
      answer: 'We provide professional medical interpreters to ensure clear communication between you and medical staff. Our multilingual support team is available throughout your treatment journey to assist with any language concerns.'
    },
    {
      id: 10,
      category: 'right',
      question: 'What are the visa and travel requirements for medical tourism in different countries?',
      answer: 'Visa requirements vary by country and your nationality. Most countries offer medical tourist visas with specific requirements. SQUARE MEDTRUST assists with visa documentation and provides guidance on travel requirements for your destination country.'
    },
    {
      id: 11,
      category: 'right',
      question: 'What is the process to book a consultation with a specialist through SQUARE MEDTRUST',
      answer: 'Submit your medical information, preferred specialist type, and availability. SQUARE MEDTRUST will match you with suitable specialists, arrange consultations (online or in-person), and facilitate communication regarding your treatment plan.'
    },
    {
      id: 12,
      category: 'right',
      question: 'Are there any fees associated with using SQUARE MEDTRUST\'s services?',
      answer: 'SQUARE MEDTRUST offers services at no upfront consultation fees. We work with partner hospitals and doctors to facilitate your treatment. Any charges are transparent and discussed with you before proceeding with bookings.'
    },
    {
      id: 13,
      category: 'right',
      question: 'Does SQUARE MEDTRUST provide support for patients after their treatment is completed?',
      answer: 'Yes, we provide post-treatment follow-up support including telemedicine consultations, rehabilitation guidance, and coordination with your home country doctor for continued care and monitoring.'
    },
    {
      id: 14,
      category: 'right',
      question: 'What documents are required to get a treatment plan and cost estimate from SQUARE MEDTRUST',
      answer: 'We typically require your medical history, recent test reports, imaging scans, current medications, and a detailed description of your condition. This helps us provide accurate treatment recommendations and cost estimates.'
    },
    {
      id: 15,
      category: 'right',
      question: 'How does SQUARE MEDTRUST handle patient privacy and confidentiality?',
      answer: 'We strictly adhere to international privacy standards and data protection regulations. All patient information is securely stored and shared only with authorized healthcare providers as necessary for treatment coordination.'
    },
    {
      id: 16,
      category: 'right',
      question: 'Are there any patient success stories or testimonials available on SQUARE MEDTRUST',
      answer: 'Yes, SQUARE MEDTRUST features numerous patient testimonials and success stories from satisfied medical tourists who have received treatment through our platform. These stories highlight real patient experiences and outcomes.'
    },
    {
      id: 17,
      category: 'right',
      question: 'What payment options are available for international patients using SQUARE MEDTRUST',
      answer: 'We accept multiple payment methods including bank transfers, credit cards, online payment gateways, and installment options. We provide flexible payment plans to accommodate different financial situations.'
    },
    {
      id: 18,
      category: 'right',
      question: 'Are there any insurance options available for medical tourists?',
      answer: 'SQUARE MEDTRUST can assist with information about travel insurance, medical tourism insurance, and coordination with your existing health insurance. We help you understand coverage options for your treatment abroad.'
    }
  ];




  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };









  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-600 text-gray-900">
      <MedtrustHeader />
      <SlidingBanner />
      <AboutSection />


      {/* <WhyChooseChina /> */}
      <WhyChooseChina />

      {/* <MedicalDevices /> */}
      <MedicalDeviceLayout />

      <section className="bg-blue-50">
        < OurTherapeuticSpecialties />
      </section>


      {/* Features in */}
      <section className="bg-white py-16">
        <div className="py-16 px-4 bg-white border-b">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-center text-3xl md:text-5xl font-bold text-blue-500 mb-12">
              Featured In
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
              {publications.map((pub, idx) => (
                <div key={idx} className="flex items-center justify-center">
                  <span className={`text-3xl md:text-3xl font-bold ${pub.color}`}>
                    {pub.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </section>

      

      <section className='bg-white'>
        <h2 className="text-center text-4xl font-bold mb-16">
          As Simple As
        </h2>

        <AsSimpleAsCard />
      </section>



      {/* Network Hospital */}


      <section >

        <HospitalLayout />
      </section>

      {/* Lowest Quotes Assured */}
       

      <section className="bg-gradient-to-br from-blue-50 to-white py-16 px-6 md:px-20">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2 mt-10">Lowest Quotes Assured</h2>
          <p className="text-gray-600 text-xl">
            We constantly negotiate better prices and alternatives without compromising treatment quality. Our prices are consistently lower.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {treatments.map((item, index) => (
            <div
              key={index}
              className="bg-slate-200 rounded-2xl p-6 flex items-center space-x-4 hover:shadow-lg transition-shadow duration-300"
            >


              <div className='bg-blue-900 p-4 rounded-full'>{item.icon}</div>
              <div>

                <h3 className="text-2xl font-semibold text-gray-800 m-2">{item.title}</h3>

                <h4 className="text-gray-600 text-xl m-2">Starting {item.price}</h4>
                <h3 className="text-red-800 text-xl font-semibold m-2">Get Quotes</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonal video */}
      <section className="bg-white py-16 px-6">
        <h2 className="text-center text-3xl md:text-4xl font-bold text-sky-950 my-10">
          SQUARE MEDTRUST Success Story - Testimonials by Patients
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-items-center px-[100px]">
          {videoData.map((video) => (
            <div
              key={video.id}
              className="w-full overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="aspect-w-16 aspect-h-9">
                <iframe
                  className="w-full h-full"
                  src={video.url}
                  title={video.title}

                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQs */}
      <section className="py-10 bg-slate-100">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-center px-4 my-8">
          Frequently Asked Questions (FAQ’s)
        </h2>

        <div className="flex flex-col lg:flex-row gap-6 px-4 sm:px-8 lg:px-20 xl:px-[90px] mx-4">
          {/* Left Column */}
          <div className="flex-1 flex flex-col gap-6">
            {faqs
              .filter((_, i) => i % 2 === 0)
              .map((faq, index) => (
                <div
                  key={faq.id}
                  className="overflow-hidden rounded-3xl shadow-sm hover:shadow-md transition-shadow duration-300"
                  style={{
                    animation: `fadeIn 0.5s ease-out ${index * 0.05}s both`,
                  }}
                >
                  <button
                    onClick={() => toggleExpand(faq.id)}
                    className={`w-full px-5 sm:px-6 py-4 text-left font-medium flex items-center justify-between transition-all duration-300 ${expanded === faq.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-slate-900 hover:bg-slate-50'
                      }`}
                  >
                    <span className="flex items-center gap-3 flex-1 text-sm sm:text-base md:text-xl">
                      <span className="text-left">{faq.question}</span>
                    </span>
                    <span
                      className={`flex-shrink-0 ml-3 text-lg sm:text-xl font-bold transition-transform duration-300 ${expanded === faq.id ? 'rotate-45' : ''
                        }`}
                    >
                      +
                    </span>
                  </button>

                  {expanded === faq.id && (
                    <div className="px-5 sm:px-6 py-4 bg-gradient-to-r from-blue-50 to-slate-50 border-t border-slate-200">
                      <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
          </div>

          {/* Right Column */}
          <div className="flex-1 flex flex-col gap-6">
            {faqs
              .filter((_, i) => i % 2 !== 0)
              .map((faq, index) => (
                <div
                  key={faq.id}
                  className="overflow-hidden rounded-3xl shadow-sm hover:shadow-md transition-shadow duration-300"
                  style={{
                    animation: `fadeIn 0.5s ease-out ${index * 0.05}s both`,
                  }}
                >
                  <button
                    onClick={() => toggleExpand(faq.id)}
                    className={`w-full px-5 sm:px-6 py-4 text-left font-medium flex items-center justify-between transition-all duration-300 ${expanded === faq.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-slate-900 hover:bg-slate-50'
                      }`}
                  >
                    <span className="flex items-center gap-3 flex-1 text-sm sm:text-base md:text-xl">
                      <span className="text-left">{faq.question}</span>
                    </span>
                    <span
                      className={`flex-shrink-0 ml-3 text-lg sm:text-xl font-bold transition-transform duration-300 ${expanded === faq.id ? 'rotate-45' : ''
                        }`}
                    >
                      +
                    </span>
                  </button>

                  {expanded === faq.id && (
                    <div className="px-5 sm:px-6 py-4 bg-gradient-to-r from-blue-50 to-slate-50 border-t border-slate-200">
                      <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      </section>



      {/* Contact Section */}
      <MedtrustFooter />


      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
          opacity: 0;
        }

        .animate-fadeInLeft {
          animation: fadeInLeft 0.8s ease-out forwards;
          opacity: 0;
        }

        .animate-fadeInRight {
          animation: fadeInRight 0.8s ease-out forwards;
          opacity: 0;
        }
          @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(-10px);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .faq-answer-enter {
          animation: slideDown 0.3s ease-out forwards;
        }

        .faq-answer-exit {
          animation: slideUp 0.3s ease-out forwards;
        }

        .icon-rotate {
          transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        }

        .icon-rotate.open {
          transform: rotate(45deg);
        }

        .button-pulse:active {
          animation: pulse 0.6s ease-out;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(0.98);
          }
          100% {
            transform: scale(1);
          }
        }

        .faq-button {
          transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        }

        .faq-button:hover {
          transform: translateX(4px);
        }

        .category-badge {
          transition: all 0.3s ease;
        }
      
      `}</style>
    </div>
  );
};

export default Medtrust;










const AboutSection = () => {
  return (
    <div className=" bg-white py-20 px-4 sm:px-6 lg:px-16">
      <div className=" mx-auto">
        {/* Header */}


        {/* Main Content Grid */}
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left Side - Illustration */}
          <div className="relative max-w-3xl">
            <img
              src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=600&fit=crop"
              alt="Medical team collaboration"
              className="w-full h-auto rounded-2xl"
            />
          </div>

          {/* Right Side - Content */}
          <div className="space-y-6">
            <h2 className="text-3xl lg:text-4xl font-bold text-blue-900 leading-tight">
              Why SQUARE MEDTRUST?
            </h2>


            {/* Feature List */}
            <div className="space-y-4 pt-4">
              <FeatureItem text="End-to-End Support: We provide multilingual support to ensure you're always understood throughout your entire health journey." />

              <FeatureItem text="Overcome Language Barriers: Our multilingual advocates ensure clear communication between you and your healthcare team." />

              <FeatureItem text="Your Needs Come First: We follow a strict 'Need-Based Service' model. You will never be pressured into unnecessary treatments." />

              <FeatureItem text="Expert-Led, Collaborative Care: Our in-house team of doctors provides comprehensive consultations and collaborates with specialists." />

              <FeatureItem text="Confident Decision-Making: Through our 'Multiple Opinion' strategy, we empower you to compare options and choose the best plan." />

              <FeatureItem text="Dedicated International Patient Services: Comprehensive support including multilingual staff, visa assistance, and tailored cultural services." />
            </div>
          </div>
        </div>


      </div>
    </div>
  );
}

function FeatureItem({ text }) {
  return (
    <div className="flex items-start gap-3">
      <div className="flex-shrink-0 mt-1">
        <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center">
          <Check className="w-4 h-4 text-teal-600" />
        </div>
      </div>
      <p className="text-gray-600 leading-relaxed">{text}</p>
    </div>
  );
}







const WhyChooseChina = () => {
   const features = [
    {
      title: 'World-Class Expertise at a Lower Cost',
      description:
        'Access highly-skilled doctors and surgeons at a fraction of the price you would pay in Singapore, Thailand, North America or Europe, without compromising on quality.',
      icon: 'assets/imgs/china/World-Class Expertise at a Lower Cost.png',
     
    },
    {
      title: 'Cutting-Edge Technology & Facilities',
      description:
        'Many major Chinese hospitals are equipped with the latest medical technology, advanced robotics, and state-of-the-art infrastructure.',
      icon: 'assets/imgs/china/Cutting-Edge Technology & Facilities.png',
      
    },
    {
      title: 'Internationally Accredited Hospitals',
      description:
        'A growing number of Chinese hospitals hold prestigious international accreditations (like JCI), ensuring they meet global standards for patient care and safety.',
      icon: 'assets/imgs/china/Internationally Accredited Hospitals.png',
    
    },
    {
      title: 'Rapid Access to Treatment',
      description:
        'Avoid long waiting times common in many countries. China offers efficient scheduling for consultations, diagnostics, and procedures.',
      icon: 'assets/imgs/china/Rapid Access to Treatment.png',
     
    },
    {
      title: 'Integrative Care Model',
      description:
        'Benefit from a unique combination of modern Western medicine with proven Traditional Chinese Medicine (TCM) for a holistic approach to healing and wellness.',
      icon: 'assets/imgs/china/Integrative Care Model.png',
      
    }
  ];

  

 return (
  <div className="successfull-experience p-8 py-5">
    <div className="mx-auto">

      {/* Header */}
      <div className="text-center mt-4 mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-3">
          Why Choose China for Your Healthcare?
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto">
          Discover world-class medical care that combines innovation, tradition, and affordability
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid md:grid-cols-5 gap-4 px-10">
        {features.map((solution, index) => (
          <div
            key={index}
            className="overflow-hidden p-6 text-center"
          >

            {/* Icon (Flat Style) */}
            <div className="flex justify-center mb-4">
              <div className="w-[75px] h-[75px] flex items-center justify-center shadow-sm">
                <img
                  src={solution.icon}
                  alt={solution.title}
                  className="object-contain"
                />
              </div>
            </div>

            {/* Content */}
            <h2 className="text-2xl font-bold text-gray-50 mb-2">
              {solution.title}
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed">
              {solution.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

}